import { IGroupedComboBoxItem } from '../GroupedComboBox/GroupedComboBox.types.shared';

export function isMatchingItem(item: IGroupedComboBoxItem, key: string | undefined): boolean {
    return item.itemKey === key;
}

/**
 * Determine if an item should be highlighted
 * @param item - The item to check
 * @param selectedKey - The selectedKey that is set on the @see GroupedComboBox component.
 * @returns true if the item should be highlighted.
 */
export function shouldHighlightItem(
    item: IGroupedComboBoxItem,
    selectedKey: string | undefined
): boolean {
    if (selectedKey === undefined) {
        return false;
    }

    if (isMatchingItem(item, selectedKey)) {
        return true;
    }

    // If this item doesn't have submenu, or if it's marked for not checking child items, it's not "selected"
    if (item.disableCheckSubItemForSelected || !item.sections) {
        return false;
    }

    // If one of the child item matches the selectedKey, consider this item selected.
    return item.sections.some((section) =>
        section.items.some((subItem) => isMatchingItem(subItem, selectedKey))
    );
}
